export const AnnotationStatus = {
    Resolved: "RESOLVED",
    Unresolved: "UNRESOLVED"
} as const;

export const AnnotationType = {
    Internal: "QA",
    External: "CLIENT"
} as const;
